import styled from 'styled-components'

export const ImageInfoContainer = styled.div`
  margin-top: var(--space-400);
`

export const UploadOrImageContainer = styled.div`
  height: 136px;
`

export const ImageInfo = styled.div`
  display: grid;
  gap: var(--space-250);
`

export const ImageInfoRecommendedSize = styled.div`
  color: var(--text-secondary);
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);
`
